/** Build a filesystem-safe file stem from the encoded text, e.g. for downloads. */
export function safeFileStem(text: string, maxLength = 60): string {
	const stem = text
		.trim()
		.replace(/^[a-z][a-z0-9+.-]*:\/\//i, "") // drop a scheme such as https://
		.replace(/[^a-zA-Z0-9]+/g, "-")
		.replace(/^-+|-+$/g, "")
		.slice(0, maxLength)
		.replace(/-+$/g, "");
	return stem || "qrcode";
}

/** Clamp a raw size input to the allowed PNG pixel range. */
export function clampSize(raw: string | number, min: number, max: number, fallback: number): number {
	const n = typeof raw === "number" ? raw : parseInt(raw, 10);
	if (!Number.isFinite(n)) return fallback;
	return Math.min(max, Math.max(min, Math.round(n)));
}
